import React from 'react';
import { Link } from 'react-router-dom';
import { History, LogIn } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import UserAvatar from '../../components/Auth/UserAvatar';

export const Header = () => {
  const { user, setShowLoginModal } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center space-x-2"
            onClick={(e) => {
              // If already on home page, reload to reset state
              if (window.location.pathname === '/') {
                e.preventDefault();
                window.location.reload();
              }
            }}
          >
            <div className="w-8 h-8 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">L</span>
            </div>
            <span className="text-lg sm:text-xl font-bold text-gray-900 hidden sm:inline">LaLala Model Maker</span>
            <span className="text-lg font-bold text-gray-900 sm:hidden">LaLala</span>
          </Link>

          <nav className="flex items-center space-x-1 sm:space-x-4">
            {user && (
              <Link
                to="/history"
                className="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-3 py-2 text-gray-600 hover:text-gray-900 rounded-lg hover:bg-gray-100"
              >
                <History className="w-4 h-4" />
                <span className="hidden sm:inline">My Uploads</span>
              </Link>
            )}
            {user ? (
              <UserAvatar />
            ) : (
              <button
                onClick={() => setShowLoginModal(true)}
                className="flex items-center space-x-1 sm:space-x-2 px-3 sm:px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                <LogIn className="w-4 h-4" />
                <span className="hidden sm:inline">Sign In</span>
              </button>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};
